export const AVAILABLE_REGIONS = globals.config.available_regions;
export const [DEFAULT_REGION] = AVAILABLE_REGIONS;
export const DEFAULT_REGION_SLUG = DEFAULT_REGION.region_slug;







// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/regions.js